import { Skeleton } from '@/components/ui/skeleton'

export const ResourceLimitsSkeleton = () => {
  return (
    <div className='relative px-24 py-6 space-y-6'>
      <div className='flex gap-x-2 items-center'>
        <Skeleton className='h-8 w-8 rounded-full' />
        <Skeleton className='h-8 w-64' />
      </div>
      <Skeleton className='h-96 w-full' />
    </div>
  )
}
